<script>
import {mapGetters, mapActions} from 'vuex'
import userActions from '@/mixins/actionsMixin'

export default {
	mixins: [userActions],
	data() {
		return {
			show: false,
			view: false,
			iframe: null,
			scormPassed: false,
			scormInit: false,
			lessonStatus: 'incompleted',
			scormInitialStatus: '',
		}
	},

	computed: {
		activity() {
			let activity = this.progressById(Number(this.$route.params.activity))
			if(!activity) {
				activity = this.activityById(Number(this.$route.params.activity))
			}
			activity.url = this.activityById(Number(this.$route.params.activity)).url
			return activity
		},
		src() {
			let view = this.activity.url
			let id = this.userId + this.activity.activityId
			let src = this.isElectron ?  '/scorm/index.html?id=' + id + view + '&scorm=' + view : '/scorm/index.html?id='  + id + view + '&scorm=' + view
			
			return src
		},
		evaluationTries() {
			return this.getEvaluationTries(Number($route.params.activity))
		},
		...mapGetters({
			activityById: 'activities/byId',
			progressById: 'auth/progressById',
			userId: 'auth/userId',
			activityViewed: 'auth/activityViewed',
			activityCompleted: 'auth/activityCompleted',
			getEvaluationTries: 'auth/evaluationTries',
			checkCanTakeEvaluation: 'auth/canTakeEvaluation',
		})
	},

	methods: {
		load(event) {
			this.iframe = event.target
			event.target.contentWindow.eventEmit = this.scormEmiter
			this.checkLessonStatus()
		},

		

		async scormEmiter(name, value) {
			let vm = this
			if(!this.scormInit) {
				this.scormInit = true
				this.checkLessonStatus()
			}

			if(name === 'cmi.core.lesson_status') {
				this.setLessomStatus(value)
			}
			if(name === 'go.to.evaluation') {
				this.setLessomStatus('completed')
				this.$router.push({name: 'formation-evaluation', params: {module: this.$route.params.module, activity: this.$route.params.activity}})
			}
			if(name === 'go.to.next') {
				this.setLessomStatus('completed')
				let activity = {...vm.activity}
				await vm.saveProgress(Object.assign(activity, {completed: true, viewed: true, userId: vm.userId}))
				vm.goNext(activity.activityId)
			}
			this.show = true
		},

		checkLessonStatus() {
			let status = this.getValueLMS('cmi.core.lesson_status')
			if(!this.scormInitialStatus) {
				this.scormInitialStatus = status
			}
			this.setLessomStatus(status)
		},

		async setLessomStatus(status) {
			let vm = this
			vm.lessonStatus = status
			
			if(status === 'passed' || status === 'completed') {
				if(!vm.activityCompleted(Number(vm.$route.params.activity)) && (!vm.activityViewed(Number(vm.$route.params.activity)) || !vm.checkCanTakeEvaluation(Number(vm.$route.params.activity)))) {
					let activity = {...vm.activity}
					if(activity.hasOwnProperty('hasEvaluation')) {
						if(activity.hasEvaluation) {
							await vm.saveProgress(Object.assign(activity, {completed: false, viewed: true, userId: vm.userId}))
							if(vm.scormInitialStatus !== 'completed') {
								vm.$router.push({name: 'formation-evaluation', params: {module: vm.$route.params.module, activity: vm.$route.params.activity}})
							}
						} else {
							await vm.saveProgress(Object.assign(activity, {completed: true, viewed: true, userId: vm.userId}))
							vm.goNext(activity.activityId)
							// if(vm.scormInitialStatus !== 'completed') {
							// 	vm.$router.push({name: 'formation-evaluation', params: {module: vm.$route.params.module, activity: vm.$route.params.activity}})
							// }
						}
						return
					}
					await vm.saveProgress(Object.assign(activity, {completed: false, viewed: true, userId: vm.userId}))
					if(vm.scormInitialStatus !== 'completed') {
						vm.$router.push({name: 'formation-evaluation', params: {module: vm.$route.params.module, activity: vm.$route.params.activity}})
					}
				}
			}
		},
		
		getValueLMS(name) {
			return this.iframe.contentWindow.API.LMSGetValue(name)
		},

		...mapActions({
			saveProgress: 'auth/saveUserProgress'
		})
	},

	mounted() {
		const vm = this
		this.saveTimeUserBack()
		setTimeout(() => {
			vm.view = true
		}, 300)
	}
}
</script>
<template>
	<div v-if="view" class="s-view-activity" >

		<transition name="fade">
			<div class="wrapper">
				<iframe v-show="show"  :src="src" @load="load" frameborder="0"></iframe>
				<div v-show="!show" class="loader-wrap">
					<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
				</div>
			</div>
		</transition>
		<footer class="evaluation__footer">
			<!-- <div v-if="activityViewed(Number($route.params.activity))" class="d-flex justify-content-center align-items-center flex-grow-1">
				<router-link :to="{name: 'formation-evaluation', params: {module: $route.params.module, activity: $route.params.activity}}" class="btn btn-primary">Iniciar trivia</router-link>
			</div> -->
			<img :src="require('@/assets/img/logo_blanco_tag.png')" alt="">
		</footer>

		
	</div>
</template>
<style lang="scss" scoped>

.s-view{
	&-activity{
		width: 100%;
		height: 100%;
		padding-left: 90px;
		display: flex;
		flex-direction: column;
		.wrapper{
			flex-grow: 1;
			width: 100%;
			height: 100%;
			margin: 0;
		}
		iframe{
			width: 100%;
			height: 100%;
			margin: 0;
		}
		.loader-wrap{
			width: 100%;
			height: 100%;
			margin: 0;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		&__footer{
			color: #fff;
			height: 60px;
			background-color: transparent;
			padding: 0.5em;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
}
.evaluation{
	
	&__footer{
		width: 100%;
		overflow: hidden;
		height: 60px;
		background-color: transparent;
		padding: 0.5rem;
		text-align: right;
		position: sticky;
		bottom: 0;
		color: #fff;
		left: 0;
		display: flex;
		// width: 100%;
		img{
			height: 100%;
			margin-left: auto;
		}
	}
}
</style>